/**
 * @generated SignedSource<<c4f4a56187ee1d99ac6ef5fd334de4c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleEditScheduleList_store$data = {
  readonly allTeams: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleListItem_team">;
  }>;
  readonly employeeScheduleTypes: ReadonlyArray<{
    readonly assignedTeams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType" | "EmployeeScheduleEditScheduleListItem_scheduleTags">;
  }>;
  readonly integrationTilTid: {
    readonly secondaryScheduleTypeOption: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly secondaryScheduleTypeOptions: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"SelectSecondaryScheduleTypeDimension_integrationTilTid">;
  } | null;
  readonly " $fragmentType": "EmployeeScheduleEditScheduleList_store";
};
export type EmployeeScheduleEditScheduleList_store$key = {
  readonly " $data"?: EmployeeScheduleEditScheduleList_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleList_store">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleEditScheduleList_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationTilTid",
      "kind": "LinkedField",
      "name": "integrationTilTid",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationTilTidSecondaryScheduleTypeOption",
          "kind": "LinkedField",
          "name": "secondaryScheduleTypeOptions",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationTilTidSecondaryScheduleTypeOption",
          "kind": "LinkedField",
          "name": "secondaryScheduleTypeOption",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SelectSecondaryScheduleTypeDimension_integrationTilTid"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "allTeams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployeeScheduleEditScheduleListItem_team"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleType",
      "kind": "LinkedField",
      "name": "employeeScheduleTypes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeams",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployeeScheduleEditScheduleListItemAssignedScheduleType_employeeScheduleType"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployeeScheduleEditScheduleListItem_scheduleTags"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "b225239fa3cf4241e88b1ccd379041bb";

export default node;
